import React from 'react';
import { useRoutedNavigation } from "presentation/hooks/useRoutedNavigation";
import { Container, Typography, Box, Button } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PageContainer from '../components/shared/pageContainer';

export function PageNotFoundComponent() {
  const { navigateTo: navigate } = useRoutedNavigation();

  return (
    <PageContainer>
      <Container maxWidth="md">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            textAlign: 'center',
            py: 8,
          }}
        >
          {/* 404 Number */}
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '6rem', md: '10rem' },
              fontWeight: 700,
              color: 'primary.main',
              lineHeight: 1,
              mb: 2,
            }}
          >
            404
          </Typography>

          {/* Error Message */}
          <Typography
            variant="h4"
            sx={{
              fontWeight: 600,
              color: 'text.primary',
              mb: 2,
            }}
          >
            Página não encontrada
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              mb: 4,
              maxWidth: '500px',
            }}
          >
            Desculpe, a página que você está procurando não existe ou foi movida.
            Verifique se o endereço está correto ou utilize os botões abaixo para navegar.
          </Typography>

          {/* Action Buttons */}
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              flexDirection: { xs: 'column', sm: 'row' },
              width: { xs: '100%', sm: 'auto' },
            }}
          >
            <Button
              variant="contained"
              size="large"
              startIcon={<HomeIcon />}
              onClick={() => navigate('/')}
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                px: 4,
                py: 1.5,
              }}
            >
              Ir para a Página Inicial
            </Button>

            <Button
              variant="outlined"
              size="large"
              startIcon={<SearchIcon />}
              onClick={() => navigate('/busca')}
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                px: 4,
                py: 1.5,
              }}
            >
              Fazer uma Busca
            </Button>
          </Box>

          {/* Additional Help */}
          <Box sx={{ mt: 6 }}>
            <Typography variant="body2" color="text.secondary">
              Se você acredita que isso é um erro, entre em contato com o suporte.
            </Typography>
          </Box>
        </Box>
      </Container>
    </PageContainer>
  );
}
